
import { Injectable, OnInit } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { Subject } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class AuthService  implements OnInit  {
    roles: Array<any> = [];
    checksprigAvailable = new Subject<any>();
    roleAccessSubscription = new Subject<any>();
    
    constructor(
        private keycloakService: KeycloakService,
    ) { }
    redirectUrl: any;
    async ngOnInit() {
        if (await this.keycloakService.isLoggedIn()) {
          this.roles = await this.keycloakService.getUserRoles();
          //console.log(roles.indexOf("activityUndo") <0 ? false : true)
          const tokens = await this.keycloakService.getToken();
          console.log(tokens)
        }
      }

    
      async checkRoleExist(roleName:any) {       
          if (await this.keycloakService.isLoggedIn()) {
              this.roles = await this.keycloakService.getUserRoles();
              return this.roles.indexOf(roleName) < 0 ? false : true;      
            }       
      }
}